import {IPPStore} from "apps/BWW_PP_WEB/modules/types";
import {createSelector} from "reselect";


export const isPPJsonsFetched = createSelector(
	[(state: IPPStore) => state.jsons_state],
	(state) => state.jsons_fetched
);
